import { Component, OnInit } from '@angular/core';
import { LoadingOverlayStoreService } from '../../services/stores/loading-overlay-store.service';
import { PropertyStoreService } from '../../services/stores/property-store.service';
import { Property } from '../../domain/property';
import { PermissionsService } from '../../services/permissions.service';
import { UserPermissions } from '../../domain/security/user-permissions';
import { environment } from '../../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';

const SUPPORT_HUB_LINK = environment.externalLinks.supportHub;
const TYALLS_SUPPORT_EMAIL = environment.emails.tyallsSupport;

@Component({
   selector: 'app-tyalls-configuration',
   templateUrl: './tyalls-configuration.component.html',
   styleUrls: ['./tyalls-configuration.component.scss']
})
export class TyallsConfigurationComponent implements OnInit {
   activeIndex = 0;
   isLoading = true;
   isAddUserVisible = false;
   isAddGroupVisible = false;
   currentSelectedProperty?: Property;

   perms = new UserPermissions();
   permsLoaded = false;

   supportHubLink = SUPPORT_HUB_LINK;
   tyallsSupportEmail = TYALLS_SUPPORT_EMAIL;

   constructor(
      private loadingOverlayStore: LoadingOverlayStoreService,
      private propStore: PropertyStoreService,
      private permissionsService: PermissionsService,
      private route: ActivatedRoute,
      private router: Router
   ) {
      this.loadingOverlayStore.LoadingState.subscribe(
         (s) => (this.isLoading = s.Users)
      );

      this.propStore.currentProperty.subscribe((p) => {
         this.currentSelectedProperty = p ?? undefined;
      });
   }

   async ngOnInit(): Promise<void> {
      try {
         this.perms = await this.permissionsService.getPermission();
      } finally {
         this.permsLoaded = true;

         this.route.queryParamMap.subscribe((params) => {
            const tab = params.get('tab');
            if (tab) this.setActiveTab(tab.toLowerCase());
         });
      }
   }

   private setActiveTab(tab: string) {
      if (tab === 'groups' && this.canGroups) {
         this.activeIndex = this.canUsers ? 1 : 0;
      } else if ((tab === 'tasks' || tab === 'taskmanagement') && this.canTasks) {
         if (this.canUsers && this.canGroups) this.activeIndex = 2;
         else if (this.canUsers || this.canGroups) this.activeIndex = 1;
         else this.activeIndex = 0;
      } else {
         this.activeIndex = 0;
      }
   }

   get canUsers() {
      return this.perms.user?.read;
   }
   get canGroups() {
      return this.perms.groups?.read;
   }
   get canTasks() {
      return this.perms.taskManagement?.read;
   }

   get hasAnyAccess() {
      return this.canUsers || this.canGroups || this.canTasks;
   }

   onTabChange(index: number) {
      const tabNames = ['users', 'groups', 'tasks'];

      this.router.navigate([], {
         relativeTo: this.route,
         queryParams: { tab: tabNames[index] },
         queryParamsHandling: 'merge'
      });
   }

   onAddUserOpen() {
      this.isAddUserVisible = true;
   }
   onDialogClose() {
      this.isAddUserVisible = false;
   }

   onAddGroupOpen() {
      this.isAddGroupVisible = true;
   }
   onGroupDialogClose() {
      this.isAddGroupVisible = false;
   }
}
